import CalendarPicker from '@mui/lab/CalendarPicker';
import { Dialog, DialogContent } from "@mui/material";
import moment, { Moment } from 'moment';
import * as React from "react";

interface IProps {
    onSelect: (value: Date) => void;
}

class DatePickerDialog extends React.PureComponent<IProps> {

    render() {
        var date = moment();

        return (
            <Dialog
                open
                role="dialog"
                onBackdropClick={() => { this.props.onSelect(null); }}
                onClose={() => { this.props.onSelect(null); }}
            >
                <DialogContent style={{ margin: 0, padding: 0 }}>

                    <CalendarPicker<Moment>
                        date={date}
                        onChange={(date) => this.props.onSelect(date.toDate())}
                    />

                </DialogContent>
            </Dialog >
        );
    }
}

export default DatePickerDialog;
